<template>
    <div class='list-wrapper'>
        <sns-scroll-load :scrollEvent='scrollEvent' :isLoading='listLoading' :parent='$parent.$refs.parent' :fullFirstScreen='true' :show-tip-text='false' :preCount='8' @load='handleLoad'
            @loaded='handleLoaded' @noMore='handleNomore'>
            <div class='item' v-for='( item, index) in tabList' :key='item.id' @click='handleItemClick( item, index)'>
                <list-tab :title='item.title' :leftSlot='""' :rightSlot='computedStr(item)' :checked='selectId == item.id || selectId == item.seq' :had-read='item.hasRead'></list-tab>
            </div>
            <template v-slot:tip>
                <v-loading v-show='!loadOver'></v-loading>
                <div v-show='loadOver' class='over-tip sub-text-88'>没有更多了</div>
            </template>
        </sns-scroll-load>
    </div>
</template>

<script>
import listTab from '@/base/list_tab'
import * as client from '@/common/js/client'
import * as utils from '@/common/js/utils'
import vLoading from '@/common/ui/loading'
export default {
    name: 'news',
    data() {
        return {
            scrollEvent: 0,
            tabList: [],
            selectId: '',
            model: {},
            listLoading: false,
            loadOver: false,
            loadTime: 0
        }
    },
    props: ['value', 'detail'],// 此处用props传值还是使用$parent 获取  还有待商榷
    inject: ['pageDetail'],
    filters: {
    },
    components: {
        listTab, vLoading
    },
    computed: {
    },
    beforeCreate: function () {
    },
    created: function () {
        let { code, tagname } = this.pageDetail;
        this.listLoading = true;
        this.$http.getListData(code, tagname, '').then(res => {
            if (res.code == 0) {
                this.listLoading = false;
                this.tabList = this.tabList.concat(res.data)
                // this.handleItemClick( res.data[0])
            }
        })
        this.$nextTick(_ => {
            this.$parent.$refs.parent.addEventListener('scroll', () => {
                this.scrollEvent = this.$parent.$refs.parent.scrollTop
            })
        })
    },
    mounted: function () {
    },
    methods: {
        computedStr(item) {
            return (item.source || "") + " " + this.$utils.thscSnsBaselibUtils.getPublishTime((item.ctime || item.time) * 1000, {
                '60s': '刚刚',
                '60m': '{nm}分钟前',
                'yesterday': '昨天{hh}:{mm}',
                '24h': '{nh}小时前',
                '1y': '{YYYY}-{MM}-{DD} {hh}:{mm}',
                'xy': '{YYYY}-{MM}-{DD}'
            })
        },
        handleItemClick(item) {
            this.selectId = item.id || item.seq;
            let obj = JSON.parse(JSON.stringify(item))
            this.$emit('input', obj);
            this.$emit('change', obj);
            item.hasRead = true;
            this.$sendStat(`pc_newschrome_0.leftlist.click`)
        },
        handleLoad(e) {
            this.listLoading = true;
            let { code, tagname } = this.pageDetail;
            let seq = this.tabList[this.tabList.length - 1].id || this.tabList[this.tabList.length - 1].seq
            // this.$sendStat( this.$pageStat( this.getCurrentSeq(), 'content_list')('contentlistload',++this.loadTime))
            this.$sendStat(`pc_newschrome_0.leftlist.switch`)
            this.$http.getListData(code, tagname, seq).then(res => {
                if (res.code == 0) {
                    this.listLoading = false;
                    this.tabList = this.tabList.concat(res.data)
                }
            })
        },
        handleLoaded(e) {
            // console.log('handleLoaded', e)
        },
        handleNomore(e) {
            this.loadOver = true;
            // this.$sendStat( this.$pageStat( this.getCurrentSeq(), 'content_list')('contentlistbotreveal'))
            this.$sendStat(`pc_newschrome_0.leftlist.switchBottom`)
        }
    }
}
</script>
<style lang="less" scoped>
@import '../../../common/style/index.less';
.list-wrapper {
    width: 243px;
    height: 100%;
    .item {
        margin-bottom: 10px;
    }
}
</style>
